import { Ng2StateDeclaration, StatesModule } from '@uirouter/angular';
import { FiStateNames } from '../../shared/fi-state-proxy/fi-state-names';
import { FiAbstractStateComponent } from '../../shared/fi-state-proxy/fi-abstract-state.component';
import { FiChecklist2ScheduleListComponent } from '@fi-shared/checklist/schedule/schedule-list/schedule-list.component';
import { FiChecklist2ScheduleEditComponent } from '@fi-shared/checklist/schedule/schedule-edit/schedule-edit.component';
import { FiStateService } from '@fi-shared/fi-state-proxy/fi-state.proxy.service';
import { Transition } from '@uirouter/core';
import { FiChecklist2ScheduleFactoryService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule-factory.service';
import { FiChecklist2ScheduleService } from '@fi-shared/checklist/schedule/services/fi-checklist2-schedule.service';
import { coerceNumberProperty } from '@angular/cdk/coercion';
import { FiChecklist2Service } from '@fi-shared/checklist/fi-checklist2.service';
import { AccessRightService } from '@fi-shared/fi-shared-services';
import { ObjectTypes } from '@fi-shared/types';
import { FiChatHelperService } from '@fi-shared/fi-chat/fi-chat-helper.service';
import {
    ChecklistV2Edit_isChatAvailable,
    ChecklistV2Edit_savedQuickSelectionFiltersResolveFn,
} from '@fi-app/checklist/checklist-v2/checklist-v2.states';

const auditMode = false;

const ChecklistV2ScheduleState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2.Schedule._name,
    url: '/Schedule',
    abstract: true,
    component: FiAbstractStateComponent,
};

export const checklistScheduleIdsResolveFn = [
    FiStateService,
    Transition,
    (fiStateService: FiStateService, tr: Transition) => fiStateService.getParams(tr).checklistScheduleIds,
];
const ChecklistV2ScheduleListState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2.Schedule.List,
    url: '/?:filterType&:sortColumn&:sortDirection&:offset',
    component: FiChecklist2ScheduleListComponent,
    params: {
        checklistScheduleIds: null,
    },
    reloadOnSearch: false,
    resolve: {
        checklistScheduleIds: checklistScheduleIdsResolveFn,
        auditMode: [() => false],
    },
};

const lightWeightChecklistsResolveFn = [
    FiChecklist2Service,
    (fiChecklist2Service: FiChecklist2Service) => fiChecklist2Service.getLightWeightChecklists(auditMode),
];

const accessRightFilterCollectionResolveFn = [
    AccessRightService,
    (accessRightService: AccessRightService) => {
        return accessRightService.getAccessRightsForPublicationByObjectType(ObjectTypes.ChecklistSchedule);
    },
];

const savedQuickSelectionFiltersResolveFn = [AccessRightService, ChecklistV2Edit_savedQuickSelectionFiltersResolveFn];

const ChecklistV2ScheduleAddState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2.Schedule.Add,
    url: '/Add',
    params: {
        checklistSchedule: null,
    },
    views: {
        '@Module': {
            component: FiChecklist2ScheduleEditComponent,
        },
    },
    resolve: {
        checklistSchedule: [
            FiStateService,
            Transition,
            FiChecklist2ScheduleFactoryService,
            (
                fiStateService: FiStateService,
                tr: Transition,
                fiChecklist2ScheduleFactoryService: FiChecklist2ScheduleFactoryService,
            ) => {
                const checkListSchedule =
                    fiStateService.getParams(tr).checklistSchedule ??
                    fiChecklist2ScheduleFactoryService.getChecklistScheduleInstance(auditMode);
                return checkListSchedule;
            },
        ],
        lightWeightChecklists: lightWeightChecklistsResolveFn,
        accessRightFilterCollection: accessRightFilterCollectionResolveFn,
        savedQuickSelectionFilters: savedQuickSelectionFiltersResolveFn,
        isChatAvailable: [FiChatHelperService, ChecklistV2Edit_isChatAvailable],
    },
};

const ChecklistV2ScheduleEditState: Ng2StateDeclaration = {
    name: FiStateNames.ChecklistV2.Schedule.Edit,
    url: '/{id:[0-9]+}/Edit',
    views: {
        '@Module': {
            component: FiChecklist2ScheduleEditComponent,
        },
    },
    resolve: {
        checklistSchedule: [
            FiStateService,
            Transition,
            FiChecklist2ScheduleService,
            (
                fiStateService: FiStateService,
                tr: Transition,
                fiChecklist2ScheduleService: FiChecklist2ScheduleService,
            ) => {
                const scheduleId = coerceNumberProperty(fiStateService.getParams(tr).id);
                return fiChecklist2ScheduleService.getChecklistSchedule(scheduleId, auditMode);
            },
        ],
        lightWeightChecklists: lightWeightChecklistsResolveFn,
        accessRightFilterCollection: accessRightFilterCollectionResolveFn,
        savedQuickSelectionFilters: savedQuickSelectionFiltersResolveFn,
        isChatAvailable: [FiChatHelperService, ChecklistV2Edit_isChatAvailable],
    },
};

export const ChecklistV2ScheduleStates: StatesModule = {
    states: [
        ChecklistV2ScheduleState,
        ChecklistV2ScheduleListState,
        ChecklistV2ScheduleAddState,
        ChecklistV2ScheduleEditState,
    ],
};
